import { createFileRoute, useSearch } from '@tanstack/react-router';
import { DocumentForm } from '@/pages/documents/form';
import { PROTECTED, ORDERS } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${ORDERS}`;

export const Route = createFileRoute('/protected/_layout/orders/_layout/new')({
  ...createSheetRouteOptions(RETURN_URL),
  component: NewOrderModal,
});

function NewOrderModal() {
  const search = useSearch({ strict: false }) as { subTab?: string };
  return <DocumentForm subTab={search.subTab} returnUrl={RETURN_URL} />;
}
